<template>
    <div class="">
        <div class="d-sm-flex align-items-center justify-content-between mb-2">
            <div>
                <ol class="breadcrumb fs-sm mb-1">
                    <li class="breadcrumb-item">
                        <router-link to="/dashboard">Dashboard</router-link>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">Plants</li>
                </ol>
                <h4 class="main-title mb-0">Plants</h4>
            </div>
            <router-link to="/plants/create" v-can="'plants.create'" type="submit" class="btn btn-primary"><i class="ri-list-check fs-18 lh-1"></i> Add Plant</router-link>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="card card-one">
                    <div class="card-header d-flex justify-content-between">
                        <h6 class="card-title">Plants</h6>
                    </div>
                    <div class="card-body ">
                        <input class="form-control mb-2" type="text" placeholder="Search" v-model="meta.search" @keyup="search()" />
                        <div class="table-responsive table-responsive-sm">
                            <table class="table table-sm table-striped text-nowrap table-bordered mb-0">
                                <thead>
                                    <tr style="background-color: #9b9b9b; color: white;">
                                        <th class="text-center">#</th>
                                        <th @click="sort('cluster_id')">
                                            Cluster
                                            <span>
                                                <i v-if="meta.keyword=='cluster_id' && meta.order_by=='asc'" class="ri-arrow-up-line"></i>
                                                <i v-else-if="meta.keyword=='cluster_id' && meta.order_by=='desc'" class="ri-arrow-down-line"></i>
                                                <i v-else class="fas fa-sort"></i>
                                            </span>
                                        </th>
                                        <th @click="sort('plant_code')">
                                            Plant Code
                                            <span>
                                                <i v-if="meta.keyword=='plant_code' && meta.order_by=='asc'" class="ri-arrow-up-line"></i>
                                                <i v-else-if="meta.keyword=='plant_code' && meta.order_by=='desc'" class="ri-arrow-down-line"></i>
                                                <i v-else class="fas fa-sort"></i>
                                            </span>
                                        </th>
                                        <th @click="sort('plant_name')">
                                            Plant Name
                                            <span>
                                                <i v-if="meta.keyword=='plant_name' && meta.order_by=='asc'" class="ri-arrow-up-line"></i>
                                                <i v-else-if="meta.keyword=='plant_name' && meta.order_by=='desc'" class="ri-arrow-down-line"></i>
                                                <i v-else class="fas fa-sort"></i>
                                            </span>
                                        </th>
                                        <th @click="sort('latitude')">
                                            Latitude
                                            <span>
                                                <i v-if="meta.keyword=='latitude' && meta.order_by=='asc'" class="ri-arrow-up-line"></i>
                                                <i v-else-if="meta.keyword=='latitude' && meta.order_by=='desc'" class="ri-arrow-down-line"></i>
                                                <i v-else class="fas fa-sort"></i>
                                            </span>
                                        </th>
                                        <th @click="sort('longitude')">
                                            Longitude
                                            <span>
                                                <i v-if="meta.keyword=='longitude' && meta.order_by=='asc'" class="ri-arrow-up-line"></i>
                                                <i v-else-if="meta.keyword=='longitude' && meta.order_by=='desc'" class="ri-arrow-down-line"></i>
                                                <i v-else class="fas fa-sort"></i>
                                            </span>
                                        </th>
                                        <th @click="sort('radius')">
                                            Radius
                                            <span>
                                                <i v-if="meta.keyword=='radius' && meta.order_by=='asc'" class="ri-arrow-up-line"></i>
                                                <i v-else-if="meta.keyword=='radius' && meta.order_by=='desc'" class="ri-arrow-down-line"></i>
                                                <i v-else class="fas fa-sort"></i>
                                            </span>
                                        </th>
                                        <th class="text-center" v-can="'plants.delete'">Status</th>
                                        <th class="text-center" v-can="'plants.update'">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="plants.length==0">
                                        <td colspan="9" class="text-center">No records found</td>
                                    </tr>
                                    <tr v-for="plant, key in plants" :key="key">
                                        <td class="text-center">{{ meta.from + key }}</td>
                                        <td>{{ plant.cluster?.cluster_name}}</td>
                                        <td>{{ plant.plant_code }}</td>
                                        <td>{{ plant.plant_name }}</td>
                                        <td>{{ plant.latitude }}</td>
                                        <td>{{ plant.longitude }}</td>
                                        <td>{{ plant.radius }}</td>
                                        <td class="text-center" v-can="'plants.delete'">
                                            <div class="form-switch">
                                                <input class="form-check-input" type="checkbox" role="switch" :id="'plant' + plant.plant_id" :checked="plant.status" :value="plant.status" @change="deletePlant(plant)" />
                                                <label class="custom-control-label" :for="'plant' + plant.plant_id"></label>
                                            </div>
                                        </td>
                                        <td class="text-center" v-can="'plants.update'">
                                            <nav>
                                                <a href="javascript:void(0)" v-if="plant.status" class="text-success me-2" @click.prevent="edit(plant)" :disabled="!plant.status"><i class="ri-pencil-line fs-18 lh-1"></i></a>
                                            </nav>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="d-flex justify-content-between align-items-center">
                            <select class="form-select from-select-sm width-75" v-model="meta.per_page" @change="onPerPageChange">
                                <option>10</option>
                                <option>15</option>
                                <option>20</option>
                                <option>25</option>
                                <option>30</option>
                            </select>
                            <span>Showing {{ meta.from }} to {{ meta.to }} of {{ meta.totalRows }} entries</span>

                            <Pagination :maxPage="meta.maxPage" :totalPages="meta.lastPage" :currentPage="meta.page" @pagechanged="onPageChange" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Pagination from "@/components/Pagination.vue";
    export default {
        components: {
            Pagination,
        },
        data() {
            return {
                meta: {
                    search: "",
                    order_by: "asc",
                    keyword: "plant_id",
                    per_page: 10,
                    totalRows: 0,
                    page: 1,
                    lastPage: 1,
                    from: 1,
                    to: 1,
                    maxPage: 1,
                    trashed: false,
                },
                plants: [],
                status: true,
                errors: [],
            };
        },
        mounted() {
            this.index();
        },

        methods: {
            index() {
                let vm = this;
                vm.$store
                    .dispatch("post", { uri: "paginatePlants", data: vm.meta })
                    .then((response) => {
                        vm.plants = response.data.data;
                        vm.meta.totalRows = response.data.meta.total;
                        vm.meta.lastPage = response.data.meta.last_page;
                        vm.meta.from = response.data.meta.from;
                        vm.meta.to = response.data.meta.to;
                        vm.meta.maxPage = vm.meta.lastPage >= 3 ? 3 : vm.meta.lastPage;
                    })
                    .catch(function (error) {
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },

            edit(plant) {
                this.$router.push("/plants/" + plant.plant_id + "/edit");
            },

            deletePlant(plant) {
                let vm = this;
                let loader = vm.$loading.show();
                // plant.status = plant.status == 1 ? 0 : 1;
                vm.$store
                    .dispatch("post", { uri: "deletePlant", data: plant })
                    .then(function (response) {                        
                        loader.hide();
                        vm.$store.dispatch("success", response.data.message);
                        vm.index();
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },

            search() {
                let vm = this;
                vm.meta.page = 1;
                vm.index();
            },

            onPageChange(page) {
                let vm = this;
                vm.meta.page = page;
                vm.index();
            },
            sort(field) {
                let vm = this;
                vm.meta.keyword = field;
                vm.meta.order_by = vm.meta.order_by == "asc" ? "desc" : "asc";
                vm.index();
            },
            onPerPageChange() {
                this.meta.page = 1;
                this.index();
            },
        },
    };
</script>
